document.querySelectorAll('[data-faq-filter]').forEach(button => {
  button.addEventListener('click', () => {
    const section = button.closest('.buyer-faq');
    const category = button.dataset.faqFilter;
    section.querySelectorAll('[data-faq-filter]').forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
    section.querySelectorAll('.faq-item').forEach(item => {
      item.hidden = category !== 'all' && item.dataset.category !== category;
      if (item.hidden) item.open = false;
    });
  });
});
